// import React, { useEffect, useState } from "react";
// import { styled } from "@mui/material/styles";
// import {
//   Box,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   TextField,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Grid,
// } from "@mui/material";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import DownloadIcon from "@mui/icons-material/Download";
// import { useDispatch, useSelector } from "react-redux";

// import { fetchNonAllocatedEmp } from "../../actions/NonAllocatedEmpAction";
// import { fetchOTNonAllocatedLoc } from "../../actions/OTNonAllocationLocAction";

// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// /* -------------------- Styles (unchanged) -------------------- */
// const PageContainer = styled(Box)(() => ({
//   maxWidth: "900px",
//   margin: "0 auto",
//   padding: "10px 15px",
//   fontFamily: "'Poppins', sans-serif",
// }));

// const StyledTableContainer = styled(TableContainer)(() => ({
//   borderRadius: "16px",
//   boxShadow: "0px 6px 15px rgba(0,0,0,0.12)",
//   border: "1px solid #d6dce5",
//   backgroundColor: "#ffffff",
//   maxHeight: "650px",
//   overflowY: "auto",
//   overflowX: "hidden",
//   position: "relative",
//   width: "100%",
// }));

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontFamily: "'Poppins', sans-serif",
//   padding: "14px 10px",
//   fontSize: "14px",
//   textAlign: "center",
//   "&.MuiTableCell-head": {
//     backgroundColor: "#154c79",
//     color: "#ffffff",
//     fontWeight: 600,
//     letterSpacing: "0.5px",
//     borderBottom: "none",
//     position: "sticky",
//     top: 0,
//     zIndex: 10,
//     "&:first-of-type": {
//       borderTopLeftRadius: "16px",
//     },
//     "&:last-of-type": {
//       borderTopRightRadius: "16px",
//     },
//   },
// }));

// const StyledTableRow = styled(TableRow)(() => ({
//   transition: "0.25s ease",
//   "&:nth-of-type(odd)": {
//     backgroundColor: "rgba(243, 246, 250, 0.6)",
//   },
//   "&:hover": {
//     backgroundColor: "rgba(14, 60, 102, 0.09)",
//     cursor: "pointer",
//   },
// }));

// /* -------------------- Component -------------------- */
// export default function NonAllocatedEmp() {
//   const dispatch = useDispatch();

//   const { loading: supLoading, data: supData } = useSelector(
//     (state) => state.nonAllocatedEmp
//   );
//   const { loading: locLoading, data: locData } = useSelector(
//     (state) => state.otNonAllocatedLoc
//   );

//   const [openDatePicker, setOpenDatePicker] = useState(false);
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [viewMode, setViewMode] = useState("supervisor");

// const formatDate = (dateObj) => {
//   const d = new Date(dateObj);
//   return d.toISOString().split("T")[0];
// };

// const formatTime = (dateObj) => {
//   const d = new Date(dateObj);
//   return d.toLocaleTimeString("en-GB", {
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//   });
// };

//   useEffect(() => {
//     const formatted = formatDate(selectedDate);
//     if (viewMode === "supervisor") {
//       dispatch(fetchNonAllocatedEmp(formatted));
//     } else {
//       dispatch(fetchOTNonAllocatedLoc(formatted));
//     }
//   }, [dispatch, viewMode, selectedDate]);

//   /* -------------------- DATA SOURCE -------------------- */
//   const currentData = viewMode === "supervisor" ? supData : locData;
//   const loading = viewMode === "supervisor" ? supLoading : locLoading;

//   /* -------------------- LOCATION FILTER -------------------- */
//   const excludedLocations = ["cad", "cac", "hao", "iim", "ism", "it"];
//   const filteredData =
//     viewMode === "location"
//       ? currentData?.filter((item) => {
//           const loc = (item.OTNon_location || item.Location || "")
//             .toLowerCase()
//             .trim();
//           return !excludedLocations.includes(loc);
//         })
//       : currentData;

//   /* -------------------- TOTAL COUNT -------------------- */
//   const totalCount = filteredData?.reduce((sum, item) => {
//     const countKey =
//       viewMode === "supervisor" ? "Non_EmpCount" : "OTNon_EmpCount";
//     return sum + Number(item[countKey] || 0);
//   }, 0);

//   const getCellValue = (item, key) => item[key] || "";

//   /* -------------------- PDF EXPORT FUNCTION -------------------- */
//   const handleExportPDF = () => {
//     const doc = new jsPDF("p", "mm", "a4");
//       const generatedAt = new Date();

//     // Add title
//     doc.setFontSize(18);
//     doc.setFont("helvetica", "bold");
//     doc.text("Non-Allocated Employees Report", 105, 15, { align: "center" });

//     // Add metadata
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(13);
//     doc.text(`View Type: ${viewMode === "supervisor" ? "Based on Supervisor" : "Based on Location"}`, 14, 32);
//     doc.setFontSize(13);
//     doc.text(`Date: ${formatDate(selectedDate)}   Time: ${formatTime(generatedAt)}`, 14, 25);
//     doc.setFontSize(13);
//     doc.setFont("helvetica", "bold");
//     doc.text(`Total Employees: ${totalCount}`, 14, 39);

//     // Prepare table data
//     let columns, rows;

//     if (viewMode === "supervisor") {
//       columns = ["Service No", "Supervisor Name", "Employee Count"];
//       rows = filteredData?.map(item => [
//         getCellValue(item, "Non_serviceNo") || getCellValue(item, "ServiceNo"),
//         getCellValue(item, "Non_SupName") || getCellValue(item, "SupervisorName"),
//         getCellValue(item, "Non_EmpCount") || getCellValue(item, "EmployeeCount")
//       ]);
//     } else {
//       columns = ["Location", "Employee Count"];
//       rows = filteredData?.map(item => [
//         getCellValue(item, "OTNon_location") || getCellValue(item, "Location"),
//         getCellValue(item, "OTNon_EmpCount") || getCellValue(item, "EmployeeCount")
//       ]);
//     }

//     // Add total row
//     if (viewMode === "supervisor") {
//       rows.push(["", "TOTAL", totalCount.toString()]);
//     } else {
//       rows.push(["TOTAL", totalCount.toString()]);
//     }

//     // Generate table
//     autoTable(doc, {
//       head: [columns],
//       body: rows,
//       startY: 48,
//       styles: {
//         fontSize: 14,
//         cellPadding: { top: 4, right: 2, bottom: 4, left: 2 },
//         halign: 'center'
//       },
//       headStyles: {
//         fillColor: [21, 76, 121],
//         textColor: 255,
//         fontStyle: 'bold'
//       },
//       alternateRowStyles: {
//         fillColor: [245, 248, 252]
//       },
//       columnStyles: viewMode === "supervisor" 
//         ? {
//             0: { cellWidth: 40, halign: 'center' },
//             1: { cellWidth: 80, halign: 'left' },
//             2: { cellWidth: 40, halign: 'center' }
//           }
//         : {
//             0: { cellWidth: 40, halign: 'center' },
//             1: { cellWidth: 40, halign: 'center' }
//           },
//       // Style the total row
//       didParseCell: function(data) {
//         if (data.row.index === rows.length - 1) {
//           data.cell.styles.fillColor = [21, 76, 121];
//           data.cell.styles.textColor = 255;
//           data.cell.styles.fontStyle = 'bold';
//         }
//       },
//       didDrawPage: function (data) {
//         const pageCount = doc.internal.getNumberOfPages();
//         doc.setFontSize(10);
//         doc.text(
//           `Page ${data.pageNumber} of ${pageCount}`,
//           doc.internal.pageSize.width - 30,
//           doc.internal.pageSize.height - 10
//         );
//       }
//     });

//     doc.save(`Non_Allocated_Employees_${formatDate(selectedDate)}.pdf`);
//   };


//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <PageContainer>
//         <Typography
//           sx={{
//             fontSize: "18px",
//             fontWeight: 700,
//             color: "#0E3C66",
//             textAlign: "center",
//             mb: 2,
//             letterSpacing: "1px",
//           }}
//         >
//           Non-Allocated Employees
//         </Typography>

//         <Grid container spacing={2} sx={{ marginBottom: 2 }}>
//           <Grid item xs={12} sm={4}>
//             <Button
//               variant="contained"
//               startIcon={<CalendarTodayIcon />}
//               onClick={() => setOpenDatePicker(true)}
//               sx={{
//                 width: "100%",
//                 height: "56px",
//                 borderRadius: "20px",
//                 backgroundColor: "#142c54",
//                 color: "#fff",
//                 fontWeight: "bold",
//                 textTransform: "none",
//                 fontSize: "16px",
//                 "&:hover": { backgroundColor: "#0D47A1" },
//               }}
//             >
//               {formatDate(selectedDate)}
//             </Button>
//           </Grid>

//           <Grid item xs={12} sm={4}>
//             <FormControl fullWidth>
//               <InputLabel
//                 sx={{
//                   fontSize: { xs: "0.85rem", sm: "1rem" },
//                   color: "#154C79",
//                 }}
//               >
//                 View Type
//               </InputLabel>
//               <Select
//                 value={viewMode}
//                 onChange={(e) => setViewMode(e.target.value)}
//                 label="View Type"
//                 sx={{
//                   fontSize: { xs: "0.85rem", sm: "1rem" },
//                   borderRadius: "20px",
//                   backgroundColor: "#F0F4F8",
//                   boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                   "& .MuiSelect-icon": {
//                     color: "#154C79",
//                   },
//                   "& .MuiOutlinedInput-notchedOutline": {
//                     borderColor: "#154C79",
//                   },
//                 }}
//                 MenuProps={{
//                   PaperProps: {
//                     sx: {
//                       maxHeight: 250,
//                       overflowY: "auto",
//                     },
//                   },
//                 }}
//               >
//                 <MenuItem value="supervisor">Based on Supervisor</MenuItem>
//                 <MenuItem value="location">Based on Location</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>

//           {!loading && filteredData?.length > 0 && (
//           <Grid item xs={12} sm={4}>
//             <Button
//               variant="contained"
//               startIcon={<DownloadIcon />}
//               onClick={handleExportPDF}
//               disabled={loading || !currentData?.length}
//               sx={{
//                 width: "100%",
//                 height: "56px",
//                 borderRadius: "20px",
//                 backgroundColor: "#2e7d32",
//                 color: "#fff",
//                 fontWeight: "bold",
//                 mb: 2,
//                 textTransform: "none",
//                 fontSize: { xs: "13px", sm: "16px" },
//                 "&:hover": { backgroundColor: "#1b5e20" },
//                 "&:disabled": {
//                   backgroundColor: "#cccccc",
//                   color: "#666666",
//                 },
//               }}
//             >
//               Export PDF
//             </Button>
//           </Grid>
//           )}
//         </Grid>

//         {openDatePicker && (
//           <DatePicker
//             open={openDatePicker}
//             value={selectedDate}
//             onChange={(date) => {
//               setSelectedDate(date);
//               setOpenDatePicker(false);
//             }}
//             onClose={() => setOpenDatePicker(false)}
//             renderInput={(params) => <TextField {...params} sx={{ display: "none" }} />}
//           />
//         )}

//         {!loading && (
//           <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
//             <Box
//               sx={{
//                 background: "#e8f0fa",
//                 border: "1px solid #bbd0ea",
//                 padding: "8px 14px",
//                 borderRadius: "8px",
//                 textAlign: "center",
//                 fontWeight: 600,
//                 color: "#0E3C66",
//               }}
//             >
//               Total Employees: {totalCount}
//             </Box>
//           </Box>
//         )}

//         <StyledTableContainer component={Paper}>
//           <Table sx={{ minWidth: "auto", width: "100%", tableLayout: "auto" }}>
//             <TableHead>
//               <TableRow>
//                 {viewMode === "supervisor" ? (
//                   <>
//                     <StyledTableCell sx={{ textAlign: "center", width: "30%" }}>
//                       Service No
//                     </StyledTableCell>
//                     <StyledTableCell sx={{ textAlign: "left", width: "45%" }}>
//                       Supervisor Name
//                     </StyledTableCell>
//                   </>
//                 ) : (
//                   <StyledTableCell sx={{ textAlign: "center", width: "50%" }}>
//                     Location
//                   </StyledTableCell>
//                 )}
//                 <StyledTableCell sx={{ textAlign: "center", width: viewMode === "supervisor" ? "25%" : "50%" }}>
//                   Employee Count
//                 </StyledTableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {!loading &&
//                 filteredData?.map((item, index) => (
//                   <StyledTableRow key={index}>
//                     {viewMode === "supervisor" ? (
//                       <>
//                         <StyledTableCell sx={{ textAlign: "center" }}>
//                           {getCellValue(item, "Non_serviceNo") || getCellValue(item, "ServiceNo")}
//                         </StyledTableCell>
//                         <StyledTableCell sx={{ textAlign: "left" }}>
//                           {getCellValue(item, "Non_SupName") || getCellValue(item, "SupervisorName")}
//                         </StyledTableCell>
//                       </>
//                     ) : (
//                       <StyledTableCell sx={{ textAlign: "center" }}>
//                         {getCellValue(item, "OTNon_location") || getCellValue(item, "Location")}
//                       </StyledTableCell>
//                     )}
//                     <StyledTableCell sx={{ textAlign: "center" }}>
//                       {viewMode === "supervisor"
//                         ? getCellValue(item, "Non_EmpCount") || getCellValue(item, "EmployeeCount")
//                         : getCellValue(item, "OTNon_EmpCount") || getCellValue(item, "EmployeeCount")}
//                     </StyledTableCell>
//                   </StyledTableRow>
//                 ))}
//               {loading && (
//                 <TableRow>
//                   <TableCell colSpan={viewMode === "location" ? 2 : 3} align="center">
//                     Loading...
//                   </TableCell>
//                 </TableRow>
//               )}
//             </TableBody>
//           </Table>
//         </StyledTableContainer>
//       </PageContainer>
//     </LocalizationProvider>
//   );
// }


import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  Grid,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DownloadIcon from "@mui/icons-material/Download";
import { useDispatch, useSelector } from "react-redux";

import { fetchOTNonAllocatedLoc } from "../../actions/OTNonAllocationLocAction";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import homeImage from "../../assets/DTS2.png";

/* -------------------- Styles -------------------- */
const PageContainer = styled(Box)(() => ({
  maxWidth: "900px",
  margin: "0 auto",
  padding: "10px 15px",
  fontFamily: "'Poppins', sans-serif",
}));

const StyledTableContainer = styled(TableContainer)(() => ({
  borderRadius: "16px",
  boxShadow: "0px 6px 15px rgba(0,0,0,0.12)",
  border: "1px solid #d6dce5",
  backgroundColor: "#ffffff",
  maxHeight: "650px",
  overflowY: "auto",
  overflowX: "hidden",
  position: "relative",
  width: "100%",
}));

const StyledTableCell = styled(TableCell)(() => ({
  fontFamily: "'Poppins', sans-serif",
  padding: "14px 10px",
  fontSize: "14px",
  textAlign: "center",
  "&.MuiTableCell-head": {
    backgroundColor: "#154c79",
    color: "#ffffff",
    fontWeight: 600,
    letterSpacing: "0.5px",
    borderBottom: "none",
    position: "sticky",
    top: 0,
    zIndex: 10,
    "&:first-of-type": { borderTopLeftRadius: "16px" },
    "&:last-of-type":  { borderTopRightRadius: "16px" },
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  transition: "0.25s ease",
  "&:nth-of-type(odd)": { backgroundColor: "rgba(243, 246, 250, 0.6)" },
  "&:hover": { backgroundColor: "rgba(14, 60, 102, 0.09)", cursor: "pointer" },
}));

/* -------------------- Component -------------------- */
export default function NonAllocatedEmp() {
  const dispatch = useDispatch();

  const { loading, data: locData } = useSelector(
    (state) => state.otNonAllocatedLoc
  );

  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const formatDate = (dateObj) => {
    const d = new Date(dateObj);
    return d.toISOString().split("T")[0];
  };

  const formatTime = (dateObj) => {
    const d = new Date(dateObj);
    return d.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  useEffect(() => {
    const formatted = formatDate(selectedDate);
    dispatch(fetchOTNonAllocatedLoc(formatted));
  }, [dispatch, selectedDate]);

  /* -------------------- FILTER -------------------- */
  const excludedLocations = ["cad", "cac", "hao", "iim", "ism", "it"];
  const filteredData =
    locData?.filter((item) => {
      const loc = (item.OTNon_location || item.Location || "").toLowerCase().trim();
      return !excludedLocations.includes(loc);
    }) || [];

  /* -------------------- TOTALS -------------------- */
  const totalCount = filteredData.reduce(
    (sum, item) => sum + Number(item.OTNon_EmpCount || 0),
    0
  );

  const getCellValue = (item, key) => item[key] || "";

  /* -------------------- PDF EXPORT -------------------- */
  const handleExportPDF = () => {
    const doc = new jsPDF("p", "mm", "a4");
    const generatedAt = new Date();
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.addImage(homeImage, "PNG", 0, 0, 210, 65);

    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(21, 76, 121);
    doc.text("Non-Allocated Employees Report", pageWidth / 2, 75, { align: "center" });

    doc.setDrawColor(21, 76, 121);
    doc.setLineWidth(0.5);
    doc.line(15, 82, pageWidth - 15, 82);

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(60, 60, 60);

    const startX = 15;
    const endX = pageWidth - 15;
    const totalWidth = endX - startX;
    const yPosition = 88;

    const section1 = startX + totalWidth * 0.125;
    const section2 = startX + totalWidth * 0.375;
    const section3 = startX + totalWidth * 0.625;
    const section4 = startX + totalWidth * 0.875;

    const dateText = "Date -  " + formatDate(selectedDate);
    const dateWidth = doc.getTextWidth(dateText);
    doc.setFont("helvetica", "bold");
    doc.text("Date -  ", section1 - dateWidth / 2, yPosition);
    doc.setFont("helvetica", "normal");
    doc.text(formatDate(selectedDate), section1 - dateWidth / 2 + doc.getTextWidth("Date -  "), yPosition);

    const timeText = "Time -  " + formatTime(generatedAt);
    const timeWidth = doc.getTextWidth(timeText);
    doc.setFont("helvetica", "bold");
    doc.text("Time -  ", section2 - timeWidth / 2, yPosition);
    doc.setFont("helvetica", "normal");
    doc.text(formatTime(generatedAt), section2 - timeWidth / 2 + doc.getTextWidth("Time -  "), yPosition);

    const viewText = "View -  Location";
    const viewWidth = doc.getTextWidth(viewText);
    doc.setFont("helvetica", "bold");
    doc.text("View -  ", section3 - viewWidth / 2, yPosition);
    doc.setFont("helvetica", "normal");
    doc.text("Location", section3 - viewWidth / 2 + doc.getTextWidth("View -  "), yPosition);

    const totalText = "Total -  " + totalCount.toString();
    const totalTextWidth = doc.getTextWidth(totalText);
    doc.setFont("helvetica", "bold");
    doc.text("Total -  ", section4 - totalTextWidth / 2, yPosition);
    doc.setFont("helvetica", "normal");
    doc.text(totalCount.toString(), section4 - totalTextWidth / 2 + doc.getTextWidth("Total -  "), yPosition);

    const columns = ["Location", "Employee Count"];
    const rows = filteredData.map((item) => [
      getCellValue(item, "OTNon_location") || getCellValue(item, "Location"),
      getCellValue(item, "OTNon_EmpCount") || getCellValue(item, "EmployeeCount"),
    ]);
    rows.push(["TOTAL", totalCount.toString()]);

    autoTable(doc, {
      head: [columns],
      body: rows,
      startY: 95,
      styles: { fontSize: 12, cellPadding: 5, lineColor: [220, 220, 220], lineWidth: 0.1 },
      headStyles: { fillColor: [21, 76, 121], textColor: [255, 255, 255], fontStyle: "bold", fontSize: 10, halign: "center", cellPadding: 6 },
      alternateRowStyles: { fillColor: [248, 249, 252] },
      columnStyles: {
        0: { cellWidth: 93.5, halign: "center" },
        1: { cellWidth: 93.5, halign: "center" },
      },
      margin: { left: 13, right: 10 },
      theme: "grid",
      didParseCell: function (data) {
        if (data.row.index === rows.length - 1) {
          data.cell.styles.fillColor = [21, 76, 121];
          data.cell.styles.textColor = 255;
          data.cell.styles.fontStyle = "bold";
        }
      },
      didDrawPage: function (data) {
        doc.setFontSize(8);
        doc.setTextColor(150);
        doc.setFont("helvetica", "italic");
        doc.text(
          `Generated on ${formatDate(generatedAt)} at ${formatTime(generatedAt)}`,
          pageWidth / 2,
          doc.internal.pageSize.getHeight() - 10,
          { align: "center" }
        );
        doc.text(`Page ${data.pageNumber}`, pageWidth - 20, doc.internal.pageSize.getHeight() - 10);
      },
    });

    doc.save(`Non_Allocated_Employees_${formatDate(selectedDate)}.pdf`);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <PageContainer>
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: 700,
            color: "#0E3C66",
            textAlign: "center",
            mb: 2,
            letterSpacing: "1px",
          }}
        >
          Non-Allocated Employees
        </Typography>

        {/* ── Date | Total | Export PDF ── */}
        <Grid container spacing={2} sx={{ mb: 2 }} alignItems="center">

          {/* Date — half width mobile, 1/3 desktop */}
          <Grid item xs={6} sm={4}>
            <Button
              variant="contained"
              startIcon={<CalendarTodayIcon />}
              onClick={() => setOpenDatePicker(true)}
              sx={{
                width: "100%",
                height: "56px",
                borderRadius: "20px",
                backgroundColor: "#142c54",
                color: "#fff",
                fontWeight: "bold",
                textTransform: "none",
                fontSize: { xs: "13px", sm: "16px" },
                "&:hover": { backgroundColor: "#0D47A1" },
              }}
            >
              {formatDate(selectedDate)}
            </Button>
          </Grid>

          {/* Total — half width mobile, 1/3 desktop */}
          <Grid item xs={6} sm={4}>
            <Box
              sx={{
                background: "#e8f0fa",
                border: "1px solid #bbd0ea",
                borderRadius: "20px",
                height: "56px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: { xs: "13px", sm: "15px" },
                color: "#0E3C66",
              }}
            >
              Total: {totalCount}
            </Box>
          </Grid>

          {/* Export PDF — full width mobile, 1/3 desktop */}
          {!loading && filteredData?.length > 0 && (
            <Grid item xs={12} sm={4}>
              <Button
                variant="contained"
                startIcon={<DownloadIcon />}
                onClick={handleExportPDF}
                disabled={loading || !locData?.length}
                sx={{
                  width: "100%",
                  height: "56px",
                  borderRadius: "20px",
                  backgroundColor: "#2e7d32",
                  color: "#fff",
                  fontWeight: "bold",
                  textTransform: "none",
                  fontSize: { xs: "13px", sm: "16px" },
                  "&:hover": { backgroundColor: "#1b5e20" },
                  "&:disabled": { backgroundColor: "#cccccc", color: "#666666" },
                }}
              >
                Export PDF
              </Button>
            </Grid>
          )}
        </Grid>

        {openDatePicker && (
          <DatePicker
            open={openDatePicker}
            value={selectedDate}
            onChange={(date) => {
              setSelectedDate(date);
              setOpenDatePicker(false);
            }}
            onClose={() => setOpenDatePicker(false)}
            renderInput={(params) => <TextField {...params} sx={{ display: "none" }} />}
          />
        )}

        <StyledTableContainer component={Paper}>
          <Table sx={{ minWidth: "auto", width: "100%", tableLayout: "auto" }}>
            <TableHead>
              <TableRow>
                <StyledTableCell sx={{ textAlign: "center", width: "50%" }}>
                  Location
                </StyledTableCell>
                <StyledTableCell sx={{ textAlign: "center", width: "50%" }}>
                  Employee Count
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!loading &&
                filteredData.map((item, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell sx={{ textAlign: "center" }}>
                      {getCellValue(item, "OTNon_location") || getCellValue(item, "Location")}
                    </StyledTableCell>
                    <StyledTableCell sx={{ textAlign: "center" }}>
                      {getCellValue(item, "OTNon_EmpCount") || getCellValue(item, "EmployeeCount")}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              {loading && (
                <TableRow>
                  <TableCell colSpan={2} align="center">
                    Loading...
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </StyledTableContainer>
      </PageContainer>
    </LocalizationProvider>
  );
}